
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 365 217","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M182.26 216.572C81.778 216.572 0 134.822 0 34.34 0 15.47 15.28.188 34.153.188c18.881 0 34.152 15.282 34.152 34.152 0 62.83 51.126 113.926 113.955 113.926 62.827 0 113.924-51.096 113.924-113.926 0-18.87 15.271-34.152 34.153-34.152 18.871 0 34.143 15.282 34.143 34.152 0 100.483-81.739 182.232-182.22 182.232z"}})])
          )
        }
      }
    